import * as React from "react";
import "../../styles.css";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Typography from "@mui/material/Typography";
import { formatNumber } from "../../hooks/Formatter";
import { setShowAlertGraph } from "../../../store/Actions";
import { useDispatch } from "react-redux";
const useStyles = makeStyles((_theme) => ({
  box: {
    display: "flex",
    alignItems: "center",
    margin: "20px 0px 60px 0px",
    cursor: "pointer"
  },
  alertTitle: {
    fontSize: "14.768px !important",
    color: "#333333 !important",
    fontWeight: "600 !important",
    fontFamily: 'Poppins, sans-serif',
    fontStyle: "normal",
    lineHeight: "18.988px !important",
  },
  subTitle: {
    fontSize: "12.659px !important",
    color: "#333333 !important",
    fontWeight: "500 !important",
    fontFamily: 'Poppins, sans-serif',
    lineHeight: "140% !important",
    display: "flex",
    width: "174.102px !important",
    height: "32px !important",
    flexDirection: "column",
    justifyContent: "center",
    flexShrink: 0,
    margin: "5px 0px !important",
  },
}));
export default function RiskDialogBox({alerts, value, title, subTitle, format, _maxValue, handleViewPowerBi }) {
  // const navigate = useNavigate();
  // const dispatch = useDispatch();
  const classes = useStyles();
  const circleRadius = 42;
  const circleSize = circleRadius * 2;

  // Ensure value is a valid number, handling cases where value is not a number
  let numericValue = Number(value);
  if (isNaN(numericValue)) {
    console.error(`Invalid number: ${value}`);  // Debugging invalid numbers
    numericValue = 0; // Fallback to 0 in case of an invalid number
  }

  // Adjust the formatted text based on the format
  let formattedText;
  if (format === "$") {
    // Formatting as currency with handling for negative values
    let absValue = Math.abs(numericValue);

    if (absValue >= 1e6) {
      // Format for millions
      formattedText = `$${(absValue / 1e6).toFixed(1)}M`;
    } else if (absValue >= 1e3) {
      // Format for thousands
      formattedText = `$${(absValue / 1e3).toFixed(1)}K`;
    } else {
      // Format for values below 1000
      formattedText = `$${Math.round(absValue)}`;
    }

    // Handle negative values
    if (numericValue < 0) {
      formattedText = `-${formattedText}`;
    }

    // If numericValue is exactly 0
    if (numericValue === 0) {
      formattedText = "$0";
    }
  } else if(format === ""){
    formattedText = `${Math.round(numericValue)}`;
  }else {
  // Formatting as percentage
  formattedText = `${Math.round(numericValue)}%`;
}

// For the circular progress bar, ensure the value used is non-negative
const percentageValue = Math.abs(Math.floor(numericValue));

// const handleAlertClick = () => {
//   navigate("/OSM");
// };

return (
  <div className={classes.box} onClick={() => handleViewPowerBi(alerts)}>
    <div style={{ width: `${circleSize}px`, height: `${circleSize}px`, marginRight: "10px" }}>
      <CircularProgressbar
        value={percentageValue}
        maxValue={100}
        text={formattedText}
        circleRatio={1}
        styles={{
          path: {
            stroke: "#3D9D0C",
          },
          trail: {
            stroke: "#DCF0E1",
          },
          text: {
            fill: "#333",
            fontSize: "17px",
            fontWeight: 700,
          },
        }}
      />
    </div>
    <div>
      <Typography className={classes.alertTitle}>{title}</Typography>
      <Typography className={classes.subTitle}>{subTitle}</Typography>
    </div>
  </div>
);
}




